import { setLoading, showSnackbar } from 'reducers/ui';
import API from 'services/api';
import { errorHandler } from 'utils/errorMessages';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import get from 'lodash/get';

import {
  attendanceActions,
  attendanceFilterActions,
  attendancePageActions,
} from 'containers/Pages/People/Attendance';

import { getTimezone } from 'reducers/utils';
import { getUserSelectedLanguage } from 'reducers/users';
import config from 'config';
const serviceUrl = config.api;
export function* fetchAttendanceListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { filters, from } = payload;
    const { data } = yield call(API.fetchAttendanceList, {
      from,
      ...filters,
    });
    if (data.data) {
      const totalEntries = get(data, 'meta.total');
      yield put(
        attendanceActions.setGridList({ list: data.data, totalEntries }),
      );
    }
    yield put(attendanceFilterActions.setFilterKey(false));
    yield put(attendanceActions.setForceRefresh(false));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* printAttendanceListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { filters, from, isCSV } = payload;
    let fetch = API.fetchAttendanceTrackingListPDF;
    const timezone = yield select(getTimezone);
    const language = yield select(getUserSelectedLanguage);
    if (isCSV) {
      fetch = API.fetchAttendanceTrackingListCSV;
    }
    const { data } = yield call(fetch, {
      from,
      timezone,
      language: language.toUpperCase(),
      ...filters,
    });
    if (data) {
      if (isCSV) {
        // the url is designed to automatically download the csv file
        window.open(`${serviceUrl}/users/attendance/shifts/csv`);
      } else {
        const { url } = data.data;
        window.open(url, '_blank');
      }
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* fetchAttendanceDetailsSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;

    const { data } = yield call(API.fetchShiftById, {
      id,
    });
    if (data.data) {
      yield put(attendanceActions.setGridRowDetails({ details: data.data }));
    }
  } catch (error) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(error),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* updateShiftItemSage({ payload }) {
  try {
    const { shiftActivity, oldShiftActivityId } = payload;
    yield put(setLoading(true));
    const { status, data } = yield call(API.updateShift, {
      shiftActivity,
      oldShiftActivityId,
    });
    if (status === 200) {
      if (data.data) {
        yield put(attendanceActions.setGridRowDetails({ details: data.data }));
      }
    }
  } catch (error) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(error),
      }),
    );
    yield put(setLoading(false));
  }
}
export function* deleteShiftItemSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { shiftActivityId } = payload;
    yield put(setLoading(true));
    const { status, data } = yield call(API.deleteShift, {
      shiftId: shiftActivityId,
    });
    if (status === 200) {
      if (data.data) {
        yield put(attendanceActions.setGridRowDetails({ details: data.data }));
      }
    }
  } catch (error) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(error),
      }),
    );
    yield put(setLoading(false));
  }
}
export function* addShiftItemSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { shift } = payload;
    const { status, data } = yield call(API.createShift, shift);
    if (status === 200) {
      if (data.data) {
        yield put(attendanceActions.setGridRowDetails({ details: data.data }));
      }
    }
  } catch (error) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(error),
      }),
    );
    yield put(setLoading(false));
  }
}
export function* attendanceSagas() {
  yield takeLatest(attendanceActions.fetchGridList, fetchAttendanceListSaga);
  yield takeLatest(
    attendanceActions.fetchGridRowDetails,
    fetchAttendanceDetailsSaga,
  );
  yield takeLatest(
    attendancePageActions.printAttendanceList,
    printAttendanceListSaga,
  );
  yield takeLatest(attendancePageActions.updateShiftItem, updateShiftItemSage);
  yield takeLatest(attendancePageActions.deleteShiftItem, deleteShiftItemSaga);
  yield takeLatest(attendancePageActions.addShiftItem, addShiftItemSaga);
}
